// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getOtpApi } from "../../services/Api/OtpApi"
import { ResendOtpApi } from "../../services/Api/ResendOtpApi"
import { getErrors, getOtpMessageSuccess } from "../reducers/otpMessageReducer"

// Watchers
function* userOtpSaga() {
	yield takeEvery("otp/getOtpMessage", getOtp)
	yield takeEvery("otp/getResendOtpMessage", getResendOtp)
}

// Sagas
function* getOtp(action) {
	// console.log(action.payload.name, "saga payload")
	try {
		const userOtpMessage = yield call(getOtpApi, action.payload)
		// console.log(userOtpMessage, "otp saga response")

		if (userOtpMessage.request.status == 200) {
			yield put(getOtpMessageSuccess(userOtpMessage))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

function* getResendOtp(action) {
	// console.log(action, "saga payload")
	try {
		const userData = yield call(ResendOtpApi, action.payload)
		// console.log(userData, "saga response")
		if (userData.status == 200) {
			yield put(getOtpMessageSuccess(userData))
		} else {
			console.log("request error")
		}
	} catch (error) {
		yield put(getErrors(error))
	}
}
export default function* rootSaga() {
	yield all([fork(userOtpSaga), fork(getResendOtp)])
}
